import devStorageWorkaround from './devStorageWorkaround.js'

class UploadService {
  
  // Función simplificada para subir archivos - solo usa el método que funciona
  async subirArchivo(archivo, ruta) {
    console.log(`🚀 Subiendo archivo: ${archivo.name} -> ${ruta}`)
    
    try {
      // Verificar que el archivo sea válido
      if (!archivo || archivo.size === 0) {
        throw new Error('Archivo inválido o vacío')
      }

      // Verificar tamaño máximo (50MB)
      const maxSize = 50 * 1024 * 1024 // 50MB para soportar videos pequeños
      if (archivo.size > maxSize) {
        throw new Error('El archivo es demasiado grande. Máximo 50MB.')
      }

      // Crear nombre único CON el nombre original preservado
      const timestamp = Date.now()
      const nombreLimpio = archivo.name
        .replace(/[^a-zA-Z0-9._-]/g, '_') // Reemplazar caracteres especiales
        .replace(/__+/g, '_') // Eliminar múltiples underscore consecutivos
      
      const rutaCompleta = `${ruta}/${timestamp}_${nombreLimpio}`

      console.log(`📁 Procesando archivo: ${rutaCompleta}`)

      // Solo usar el método de desarrollo que funciona
      const resultado = await devStorageWorkaround.uploadFile(archivo, rutaCompleta)
      
      console.log(`✅ Archivo subido exitosamente: ${archivo.name}`)
      
      // ⭐ IMPORTANTE: Retornar objeto con TODAS las propiedades esperadas
      return {
        nombre: resultado.nombre || resultado.name || archivo.name,
        nombre_original: resultado.nombre_original || resultado.name || archivo.name,
        url: resultado.url,
        path: resultado.path || rutaCompleta,
        tamano: resultado.tamano || resultado.size || archivo.size,
        tipo: resultado.tipo || resultado.type || archivo.type,
        size: resultado.size || archivo.size,
        type: resultado.type || archivo.type,
        isDevelopmentMock: resultado.isDevelopmentMock || false,
        timestamp: resultado.timestamp || Date.now(),
        extension: resultado.extension
      }

    } catch (error) {
      console.error('❌ Error en subirArchivo:', error)
      throw this.handleUploadError(error)
    }
  }

  // Subir múltiples archivos con manejo de errores individual
  async subirMultiplesArchivos(archivos, rutaBase) {
    console.log(`📦 Subiendo ${archivos.length} archivos a ${rutaBase}`)
    
    const resultados = []
    const errores = []

    for (let i = 0; i < archivos.length; i++) {
      try {
        const resultado = await this.subirArchivo(archivos[i], rutaBase)
        resultados.push(resultado)
      } catch (error) {
        console.error(`❌ Error subiendo archivo ${i + 1}:`, error)
        errores.push({
          archivo: archivos[i].name,
          error: error.message
        })
      }
    }

    return {
      exitosos: resultados,
      errores: errores,
      total: archivos.length
    }
  }

  // Manejo simplificado de errores
  handleUploadError(error) {
    console.error('🔍 Error de subida:', error)
    
    if (error.message.includes('Failed to fetch') || error.message.includes('net::ERR_FAILED')) {
      return new Error('Error de conexión. Verifica tu internet y vuelve a intentar.')
    }

    return new Error(`Error subiendo archivo: ${error.message}`)
  }

  // Validar archivos antes de subir
  validarArchivos(archivos, tiposPermitidos = [], tamañoMaximo = 10 * 1024 * 1024) {
    const errores = []

    archivos.forEach((archivo, index) => {
      // Verificar si el archivo existe
      if (!archivo) {
        errores.push(`Archivo ${index + 1}: No se pudo leer el archivo`)
        return
      }

      // Verificar tamaño
      if (archivo.size > tamañoMaximo) {
        const tamañoMB = (tamañoMaximo / (1024 * 1024)).toFixed(1)
        errores.push(`${archivo.name}: Archivo muy grande (máximo ${tamañoMB}MB)`)
      }

      // Verificar tipo si se especifica
      if (tiposPermitidos.length > 0) {
        const tipoValido = tiposPermitidos.some(tipo => 
          archivo.type.includes(tipo) || archivo.name.toLowerCase().endsWith(tipo)
        )
        if (!tipoValido) {
          errores.push(`${archivo.name}: Tipo no permitido. Permitidos: ${tiposPermitidos.join(', ')}`)
        }
      }
    })

    return errores
  }
}

export default new UploadService()
